import React from "react";
import { Card } from "react-bootstrap";
import "../../assets/css/vendors/HotelComponents/dashboardCard.css";

const DashboardCard = ({
  title,
  value,
  badgeText,
  icon,
  cardClass = "",
  iconBg = "",
  iconColor = "",
  additionalInfo = "",
  isCurrency = false
}) => {
  return (
  <Card className={`hotel-db-card ${cardClass}`} style={{ minHeight: "200px" }}>   
     <Card.Body className="hotel-db-card-body">
        <div className="hotel-db-card-inner">
          <div className="d-flex justify-content-between align-items-start">
            <div className="hotel-db-card-info">
              <h6 className="hotel-db-card-label">{title}</h6>
              <h3 className="hotel-db-card-value">
                {isCurrency 
                  ? `Rs. ${value.toLocaleString("en-IN")}` 
                  : value}
              </h3>
              <div className="hotel-db-card-details">
                <span className="hotel-db-badge">
                  {badgeText}
                </span>
                {additionalInfo && (
                  <span className="hotel-db-card-trend">
                    {additionalInfo}
                  </span>
                )}
              </div>
            </div>
            <div
              className={`hotel-db-icon ${iconBg} ${iconColor}`}
            >
              {icon}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DashboardCard;